const themingReducer = (state, action) => {
    if (state === undefined) {
        let storedOption;
        if (localStorage.getItem('darkMode') === null) {
            storedOption = true;
        } else {
            storedOption = localStorage.getItem('darkMode') === 'true';
        }
        state = {
            ...state,
            darkMode: storedOption
        }
        return state;
    }
    switch (action.type) {
        case "SWITCH_MODE":
            localStorage.setItem('darkMode', (!state.darkMode).toString());
            const newMode = !state.darkMode;
            return {
                ...state,
                darkMode: newMode
            }
            default:
            return state
    }


}

export default themingReducer;
